import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { useEditRecipientTaxIdentifiersFormContext } from './context';
import messages from './messages';

export const ErrorBanner = () => {
  const { isApiError } = useEditRecipientTaxIdentifiersFormContext();

  if (!isApiError) {
    return null;
  }

  return <BannerMessageV2 content={<FormattedMessage {...messages.errorBannerText} />} status={BannerStatus.Error} />;
};
